import React, { useState } from 'react'
import { Box, Button, Stack, Tooltip, Typography, IconButton, useMediaQuery } from '@mui/material'
import offerImage from '../../assets/images/offerImage.jpeg'
import Logo from '../../assets/images/pngIcon.png'
// import Header from '../../components/Header'
import axios from 'axios'
import ContactSection from './ContactUs'
import WhyChooseUsSection from './WhyChooseUs'
import { Link } from 'react-router-dom'
import { useSnackbar } from '../../components/SnackbarProvider'
// import OurClientsSection from './OurClients'
import HowItWorksSection from './HowItWorks'
import MainSection from './MainSection'
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import gpsBtnImage from '../../assets/images/google play store.png'
import apsBtnImage from '../../assets/images/apple play store.png'
import Testimonials from './Testimonials'
const HomeIndex = () => {
  // console.log('home Index')
  const currentDate = new Date()
  const targetDate = new Date('2024-12-31')
  const [isVisible, setIsVisible] = React.useState(false)
  const [remindMeLater, setRemindMeLater] = React.useState(false)

  const [downloadProgress, setDownloadProgress] = useState(0)
  const [isDownloading, setIsDownloading] = useState(false)
  const small = useMediaQuery('(max-width:600px)')
  const showSnackbar = useSnackbar()
  // new year offer popup
  React.useEffect(() => {
    // Check sessionStorage to see if the popup should be hidden
    const popupClosed = sessionStorage.getItem('popupClosed')
    if (!popupClosed) {
      const showPopup = () => {
        setIsVisible(true)
        setTimeout(() => {
          setIsVisible(false)
        }, 15000) // Popup stays for 15 seconds
      }

      // Show popup after 30 seconds initially
      const initialTimer = setTimeout(() => {
        showPopup()
        // Start the interval only after the first popup is shown and hidden
        const intervalId = setInterval(showPopup, 45000) // 30 seconds wait + 15 seconds display time
        // Clear the interval when the component unmounts
        return () => {
          clearInterval(intervalId)
        }
      }, 10000)

      // Clear the initial timer when the component unmounts
      return () => {
        clearTimeout(initialTimer)
      }
    }
  }, [])

  const handleDownload = async () => {
    // const fileUrl = 'https://lawttorney.ai/api/users/apkdownload'
    // const link = document.createElement('a')
    // link.href = fileUrl
    // // This suggests to the browser that the file should be downloaded
    // // rather than opened in the same tab
    // link.setAttribute('download', 'setup.exe')
    // document.body.appendChild(link)
    // link.click()
    // document.body.removeChild(link)
    //   try {
    //     setIsDownloading(true)
    //     setDownloadProgress(0)
    //     const response = await axios({
    //       url: 'http://lawttorney.ai/api/users/apkdownload',
    //       method: 'GET',
    //       responseType: 'blob',
    //       onDownloadProgress: (progressEvent: any) => {
    //         if (progressEvent.total && progressEvent.loaded) {
    //           const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    //           setDownloadProgress(percentCompleted)
    //         } else {
    //           console.log('Unable to calculate download progress')
    //         }
    //       },
    //     })
    //     console.log('response', response)
    //     const url = window.URL.createObjectURL(new Blob([response.data]))
    //     const link = document.createElement('a')
    //     link.href = url
    //     link.setAttribute('download', 'setup.exe')
    //     document.body.appendChild(link)
    //     link.click()
    //     // Clean up
    //     window.URL.revokeObjectURL(url)
    //     document.body.removeChild(link)
    //   } catch (error) {
    //     console.error('Download failed:', error)
    //   } finally {
    //     setIsDownloading(false)
    //   }
  }

  // new year popup close
  const handleRemindMeLater = () => {
    setRemindMeLater(true)
    setIsVisible(false)
    sessionStorage.setItem('popupClosed', 'true') // Set popupClosed in sessionStorage
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 7.5, mt: 12 }}>
        {/* <Header maxWidth='false' /> */}
        <MainSection />
        <HowItWorksSection />
        {/* <OurClientsSection /> */}
        <WhyChooseUsSection />
        <Testimonials />
        <ContactSection />
      </Box>
      {isVisible && !remindMeLater && currentDate <= targetDate && (
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '10003',
          }}
          // onClick={handleOfferPlan}
        >
          <img src={offerImage} width='50%' alt='Offer valid till 31st Dec 24' />
          <Stack
            sx={{
              width: '50%',
              bgcolor: '#777',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button style={{ width: '400px', padding: '10px 0px' }} onClick={handleRemindMeLater}>
              Remind me later
            </Button>
          </Stack>
        </Box>
      )}

      {/* for footer section */}
      <Stack sx={{ marginTop: '2rem', display: 'flex', alignItems: 'center' }}>
        <Typography variant='h6' component={'div'} color='initial'>
          Follow us
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Link to='https://www.facebook.com/share/1BsFpAygTS/?mibextid=wwXIfr' target='_blank'>
            <Tooltip title='Facebook'>
              <FacebookIcon
                fontSize='large'
                sx={{ mx: '10px', color: '#4267B2', cursor: 'pointer' }}
              />
            </Tooltip>
          </Link>

          <Link to='https://www.linkedin.com/company/lawttorneydotai/' target='_blank'>
            <Tooltip title='LinkedIn'>
              <LinkedInIcon fontSize='large' sx={{ mx: '20px', color: '#0077B5' }} />
            </Tooltip>
          </Link>

          <Link
            to='https://www.instagram.com/lawttorney.ai?igsh=bWlrZzBnMnU5eDAw&utm_source=qr'
            target='_blank'
          >
            <Tooltip title='Instagram'>
              <InstagramIcon fontSize='large' sx={{ mx: '20px', color: '#E1306C' }} />
            </Tooltip>
          </Link>

          <Link to='https://youtube.com/@lawttorney?si=uMh5Gil_6pChVfFo' target='_blank'>
            <Tooltip title='YouTube'>
              <YouTubeIcon fontSize='large' sx={{ mx: '20px', color: 'red' }} />
            </Tooltip>
          </Link>
        </Box>

        <Box sx={{ mt: 1, display: 'flex' }}>
          <Link
            to='https://play.google.com/store/apps/details?id=com.lawtech&pcampaignid=web_share'
            target='_blank'
          >
            <img
              src={gpsBtnImage}
              alt='google play store image'
              height='52px'
              style={{ margin: '-3.5px 10px 0 0', cursor: 'pointer' }}
              // onClick={handleDownload}
            />
          </Link>

          <Box>
            <Link to='https://apps.apple.com/in/app/lawttorney-ai/id6747644584' target='_blank'>
              <img
                src={apsBtnImage}
                alt='Apple play store image'
                height='52px'
                style={{ margin: '-3.5px 0 0 0', cursor: 'pointer' }}
                onClick={() => {
                  showSnackbar('Coming soon on Apple store', 'info')
                }}
              />
            </Link>
          </Box>
        </Box>

        {isDownloading && (
          <div className='progress-container'>
            <progress value={downloadProgress} max='100' />
            <span>{` ${downloadProgress} %`}</span>
          </div>
        )}
      </Stack>

      {/*  New Separate Footer for home page only */}
      <div
        style={{
          marginTop: '2rem',
          backgroundColor: '#ffe991',
          padding: '1rem', // p-6
          paddingBottom: '0.5rem',
          borderRadius: '0.5rem', // rounded-lg
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'grid',
            gridTemplateColumns: small ? '1fr' : '1fr 1fr 1fr',
            justifyContent: 'space-around',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img
              src={Logo}
              alt='Lawttorney Logo'
              style={{ height: small ? 80 : 100, width: 'auto' }}
            />
          </Box>

          <Box sx={{ p: 2 }}>
            {' '}
            <Typography variant='subtitle1' textAlign={'center'} color={'#777'}>
              © {new Date().getFullYear()} by{' '}
              <span style={{ fontWeight: 'bold' }}>
                LAWTTORNEY ARTIFICIAL INTELLIGENCE PRIVATE LIMITED, India
              </span>
            </Typography>
            <Typography
              textAlign={'center'}
              variant='body1'
              color='initial'
              sx={{ letterSpacing: '0.05em' }}
            >
              CIN: U62011PN2025PTC249243
            </Typography>
          </Box>

          <Box sx={{ p: 2 }}></Box>
        </Box>
      </div>
    </>
  )
}

export default HomeIndex
